/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import {
	useIsStandardOrFreeJSW,
	useIsUnlicensedJSW,
} from '@jira/navigation-apps__atlassian-navigation/src/controllers/edition/index.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { PACKAGE_NAME, TEAM_NAME } from './ui/constants.tsx';

import {
	Nav4Plans as Nav4PlansWithoutErrorBoundary,
	type Nav4PlansProps,
} from './ui/plans/Nav4Plans.tsx';
import { Nav4PlansPremiumUpsellFeatureGate } from './ui/plans/premium-upsell-feature-gate/Nav4PlansPremiumUpsellFeatureGate.tsx';

export function Nav4Plans(props: Nav4PlansProps): React.JSX.Element | null {
	const isStandardOrFree = useIsStandardOrFreeJSW();
	const isUnlicensedJsw = useIsUnlicensedJSW();

	if (isUnlicensedJsw) {
		return null;
	}

	if (isStandardOrFree) {
		const actualProps = fg('navx-global-side-nav') ? props : {};
		return <Nav4PlansPremiumUpsellFeatureGate {...actualProps} />;
	}

	return (
		<UFOSegment name="nav4.sidebar.plans">
			<JSErrorBoundary
				fallback="flag"
				id="plans-section"
				packageName={PACKAGE_NAME}
				teamName={TEAM_NAME}
			>
				<Nav4PlansWithoutErrorBoundary {...props} />
			</JSErrorBoundary>
		</UFOSegment>
	);
}
